import S from "@babel/runtime/helpers/esm/objectSpread2";
import w from "@babel/runtime/helpers/esm/classCallCheck";
import P from "@babel/runtime/helpers/esm/createClass";
import y from "@babel/runtime/helpers/esm/assertThisInitialized";
import O from "@babel/runtime/helpers/esm/inherits";
import A from "@babel/runtime/helpers/esm/createSuper";
import l from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as E } from "@semcore/utils/lib/core/index";
import C, { sstyled as x, assignProps as I, Component as k } from "@semcore/core";
import o from "react";
import { InvalidStateBox as D, Box as L } from "@semcore/flex-box";
import f from "@semcore/neighbor-location";
import B from "@semcore/utils/lib/enhances/autoFocusEnhance";
import F from "@semcore/utils/lib/enhances/keyboardFocusEnhance";
var R = (
  /*__reshadow_css_start__*/
  (E.insert(
    /*__inner_css_start__*/
    ".___SInput_1azly_gg_{display:inline-flex;width:100%;align-items:center;position:relative;z-index:0;vertical-align:middle;padding:1px;box-sizing:border-box}.___SInput_1azly_gg_ input:-webkit-autofill{border-radius:var(--intergalactic-control-rounded, 6px);-webkit-box-shadow:0 0 0 30px #faffbd inset}.___SInput_1azly_gg_ input:-webkit-autofill~.___SOutline_1azly_gg_{background-color:#faffbd}.___SValue_1azly_gg_{min-width:0;width:100%;height:100%;padding:0;border:0;box-sizing:border-box;color:var(--intergalactic-text-primary, #191b23);font-size:inherit;text-overflow:ellipsis;font-family:inherit;background:0 0}.___SValue_1azly_gg_:focus{outline:0}.___SValue_1azly_gg_::-moz-placeholder{color:var(--intergalactic-text-placeholder, #8a8e9b)}.___SValue_1azly_gg_::placeholder{color:var(--intergalactic-text-placeholder, #8a8e9b)}.___SValue_1azly_gg_:not(:disabled):-moz-read-only~.___SOutline_1azly_gg_{background:var(--intergalactic-bg-secondary-neutral, #f4f5f9)}.___SValue_1azly_gg_:not(:disabled):read-only~.___SOutline_1azly_gg_{background:var(--intergalactic-bg-secondary-neutral, #f4f5f9)}.___SValue_1azly_gg_:disabled{-webkit-user-select:none;-moz-user-select:none;user-select:none;opacity:var(--intergalactic-disabled-opacity, 0.3)}.___SInput_1azly_gg_.__disabled_1azly_gg_ .___SOutline_1azly_gg_,.___SValue_1azly_gg_:disabled~.___SOutline_1azly_gg_{opacity:var(--intergalactic-disabled-opacity, 0.3);cursor:default;pointer-events:none}.___SOutline_1azly_gg_{position:absolute;top:0;right:0;bottom:0;left:0;border:1px solid;border-radius:var(--intergalactic-control-rounded, 6px);z-index:-1;background:var(--intergalactic-bg-primary-neutral, #ffffff)}.___SAddon_1azly_gg_{display:inline-flex;justify-content:center;align-items:center;flex:0 0 auto;padding:0 var(--intergalactic-spacing-2x, 8px);height:100%;color:var(--intergalactic-icon-secondary-neutral, #a9abb6)}.___SAddon_1azly_gg_.__interactive_1azly_gg_{cursor:pointer}@media (hover:hover){.___SAddon_1azly_gg_.__interactive_1azly_gg_:hover{color:var(--intergalactic-icon-secondary-neutral-hover-active, #878992)}}.___SAddon_1azly_gg_.__disabled_1azly_gg_{opacity:var(--intergalactic-disabled-opacity, 0.3);cursor:default;pointer-events:none}.___SAddon_1azly_gg_._size_m_1azly_gg_:not(.___SButton_1azly_gg_){padding:0 var(--intergalactic-spacing-2x, 8px)}.___SAddon_1azly_gg_._size_l_1azly_gg_:not(.___SButton_1azly_gg_){padding:0 var(--intergalactic-spacing-2x, 8px)0 var(--intergalactic-spacing-3x, 12px)}.___SInput_1azly_gg_ .___SAddon_1azly_gg_:nth-last-child(2){margin-right:-1px}.___SValue_1azly_gg_._size_m_1azly_gg_{padding:0 var(--intergalactic-spacing-2x, 8px)}.___SValue_1azly_gg_._size_l_1azly_gg_{padding:0 var(--intergalactic-spacing-3x, 12px)}.___SInput_1azly_gg_._size_m_1azly_gg_{font-size:var(--intergalactic-fs-200, 14px);height:var(--intergalactic-form-control-m, 28px)}.___SInput_1azly_gg_._size_l_1azly_gg_{font-size:var(--intergalactic-fs-300, 16px);height:var(--intergalactic-form-control-l, 40px)}.___SInput_1azly_gg_.__focused_1azly_gg_{z-index:1}.___SInput_1azly_gg_._state_normal_1azly_gg_ .___SOutline_1azly_gg_{border-color:var(--intergalactic-border-primary, #c4c7cf)}.___SInput_1azly_gg_._state_normal_1azly_gg_.__focused_1azly_gg_ .___SOutline_1azly_gg_{border-color:var(--intergalactic-border-info-active, #006dca);box-shadow:var(--intergalactic-keyboard-focus, 0px 0px 0px 3px rgba(0, 143, 248, 0.5))}.___SInput_1azly_gg_._state_valid_1azly_gg_ .___SOutline_1azly_gg_{border-color:var(--intergalactic-border-success-active, #007c65)}.___SInput_1azly_gg_._state_valid_1azly_gg_.__focused_1azly_gg_ .___SOutline_1azly_gg_{border-color:var(--intergalactic-border-success-active, #007c65);box-shadow:var(--intergalactic-keyboard-focus-valid, 0px 0px 0px 3px rgba(0, 159, 129, 0.5))}.___SInput_1azly_gg_._state_invalid_1azly_gg_ .___SOutline_1azly_gg_{border-color:var(--intergalactic-border-critical-active, #d1002f)}.___SInput_1azly_gg_._state_invalid_1azly_gg_.__focused_1azly_gg_ .___SOutline_1azly_gg_{border-color:var(--intergalactic-border-critical-active, #d1002f);box-shadow:var(--intergalactic-keyboard-focus-invalid, 0px 0px 0px 3px rgba(255, 73, 83, 0.5))}.___SInput_1azly_gg_._neighborLocation_right_1azly_gg_ .___SOutline_1azly_gg_{border-top-right-radius:0;border-bottom-right-radius:0}.___SInput_1azly_gg_._neighborLocation_both_1azly_gg_ .___SOutline_1azly_gg_{border-radius:0;border-left:none}.___SInput_1azly_gg_._neighborLocation_left_1azly_gg_ .___SOutline_1azly_gg_{border-top-left-radius:0;border-bottom-left-radius:0;border-left:none}.___SValue_1azly_gg_._neighborLocation_right_1azly_gg_{padding-right:0}.___SValue_1azly_gg_._neighborLocation_both_1azly_gg_{padding-left:0;padding-right:0}.___SValue_1azly_gg_._neighborLocation_left_1azly_gg_{padding-left:0}",
    "1azly_gg_"
  ), {
    __SInput: "___SInput_1azly_gg_",
    _disabled: "__disabled_1azly_gg_",
    __SOutline: "___SOutline_1azly_gg_",
    __SValue: "___SValue_1azly_gg_",
    __SAddon: "___SAddon_1azly_gg_",
    _size_m: "_size_m_1azly_gg_",
    __SButton: "___SButton_1azly_gg_",
    _size_l: "_size_l_1azly_gg_",
    _focused: "__focused_1azly_gg_",
    _neighborLocation_right: "_neighborLocation_right_1azly_gg_",
    _neighborLocation_both: "_neighborLocation_both_1azly_gg_",
    _neighborLocation_left: "_neighborLocation_left_1azly_gg_",
    _interactive: "__interactive_1azly_gg_",
    _state_normal: "_state_normal_1azly_gg_",
    _state_valid: "_state_valid_1azly_gg_",
    _state_invalid: "_state_invalid_1azly_gg_"
  })
), z = /* @__PURE__ */ function(g) {
  O(n, g);
  var c = A(n);
  function n() {
    var a;
    w(this, n);
    for (var _ = arguments.length, i = new Array(_), t = 0; t < _; t++)
      i[t] = arguments[t];
    return a = c.call.apply(c, [this].concat(i)), l(y(a), "state", {
      focused: !1
    }), l(y(a), "inputRef", /* @__PURE__ */ o.createRef()), l(y(a), "handleMouseDownAddon", function(r) {
      var e;
      r.preventDefault(), (e = a.inputRef.current) === null || e === void 0 || e.focus();
    }), l(y(a), "handleKeyDown", function(r) {
      r.key === "Enter" && setTimeout(function() {
        if (document.activeElement === document.body) {
          var e;
          (e = a.inputRef.current) === null || e === void 0 || e.focus();
        }
      }, 10);
    }), l(y(a), "bindHandleValueFocused", function(r) {
      return function() {
        return a.setState({
          focused: r
        });
      };
    }), a;
  }
  return P(n, [{
    key: "getAddonProps",
    value: function() {
      var _ = this.asProps, i = _.disabled, t = _.size;
      return {
        disabled: i,
        onMouseDown: this.handleMouseDownAddon,
        size: t
      };
    }
  }, {
    key: "getValueProps",
    value: function() {
      var _ = this.asProps, i = _.size, t = _.disabled, r = _.state, e = _.role, u = _.placeholder, p = _["aria-haspopup"], d = _["aria-controls"], b = _["aria-expanded"], h = _["aria-autocomplete"], v = _["aria-owns"], m = _["aria-activedescendant"];
      return {
        ref: this.inputRef,
        size: i,
        disabled: t,
        state: r,
        onFocus: this.bindHandleValueFocused(!0),
        onBlur: this.bindHandleValueFocused(!1),
        role: e,
        placeholder: u,
        "aria-haspopup": p,
        "aria-controls": d,
        "aria-expanded": b,
        "aria-autocomplete": h,
        "aria-owns": v,
        "aria-activedescendant": m
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function(_) {
      _.disabled !== this.asProps.disabled && this.asProps.disabled && this.setState({
        focused: !1
      });
    }
  }, {
    key: "render",
    value: function() {
      var _ = this.asProps, i = this, t = L, r = "div", e = this.asProps, u = e.Children, p = e.styles, d = e.neighborLocation, b = e.controlsLength, h = e.state, v = this.state.focused;
      return /* @__PURE__ */ o.createElement(f.Detect, {
        neighborLocation: d
      }, function(m) {
        var s;
        return s = x(p), /* @__PURE__ */ o.createElement(t, s.cn("SInput", S({}, I({
          focused: v,
          onKeyDown: i.handleKeyDown,
          neighborLocation: m,
          __excludeProps: ["role", "aria-haspopup", "aria-controls", "aria-expanded", "placeholder", "aria-autocomplete", "aria-owns", "aria-activedescendant", "tabIndex"]
        }, _))), /* @__PURE__ */ o.createElement(f, s.cn("NeighborLocation", {
          controlsLength: b
        }), /* @__PURE__ */ o.createElement(u, s.cn("Children", {}))), /* @__PURE__ */ o.createElement(r, s.cn("SOutline", {}), h === "invalid" && /* @__PURE__ */ o.createElement(D, s.cn("InvalidStateBox", {}))));
      });
    }
  }]), n;
}(k);
l(z, "displayName", "Input");
l(z, "defaultProps", {
  size: "m",
  state: "normal"
});
l(z, "style", R);
var V = /* @__PURE__ */ function(g) {
  O(n, g);
  var c = A(n);
  function n() {
    return w(this, n), c.apply(this, arguments);
  }
  return P(n, [{
    key: "uncontrolledProps",
    value: function() {
      return {
        value: function(i) {
          return i.target.value;
        }
      };
    }
  }, {
    key: "render",
    value: function() {
      var _ = this.asProps, i = L, t = this.asProps, r = t.styles, e = t.neighborLocation, u = t.state;
      return /* @__PURE__ */ o.createElement(f.Detect, {
        neighborLocation: e
      }, function(p) {
        var d;
        return d = x(r), /* @__PURE__ */ o.createElement(i, d.cn("SValue", S({}, I({
          neighborLocation: p,
          tag: "input",
          type: "text",
          "aria-invalid": u === "invalid"
        }, _))));
      });
    }
  }]), n;
}(k);
l(V, "defaultProps", {
  defaultValue: ""
});
l(V, "enhance", [F(), B()]);
function H(g) {
  var c = arguments[0], n = L, a = g.Children, _ = g.styles, i = g.neighborLocation;
  return /* @__PURE__ */ o.createElement(f.Detect, {
    neighborLocation: i
  }, function(t) {
    var r;
    return r = x(_), /* @__PURE__ */ o.createElement(n, r.cn("SAddon", S({}, I({
      neighborLocation: t
    }, c))), /* @__PURE__ */ o.createElement(a, r.cn("Children", {})));
  });
}
const Z = C(z, {
  Addon: H,
  Value: V
});
export {
  Z as default
};
